import script from "./FileCard.vue?vue&type=script&setup=true&lang=js"
export * from "./FileCard.vue?vue&type=script&setup=true&lang=js"

import "./FileCard.vue?vue&type=style&index=0&id=60d86a78&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60d86a78"]])

export default __exports__